import React from 'react';
import Typewriter from 'typewriter-effect';
import './Blogs.css'

const Blogs = () => {
    return (
        <div className="bg-gray-300 fixer ">
            <div className=" text-center text-5xl font-bold text-red-700 py-5">
                <Typewriter
                options={{
                    strings:['Coming Soon'],
                    autoStart: true,
                    loop: true,
                    delay:50,
                    deleteSpeed:50
                }}
                />
                </div>
        </div>
    );
};

export default Blogs;